import { throttle } from '../../utils';

const Header = () => {
  const initMobileMenu = () => {
    const component = document.querySelector('.js-header');

    if (component) {
      const menuBody = component.querySelector('.js-header-menu');
      const menuBtnsContainer = component.querySelector('.js-header-buttons');
      const openBtn = component.querySelector('.js-header-open');
      const closeBtn = component.querySelector('.js-header-close');

      if (menuBody && menuBtnsContainer && openBtn && closeBtn) {
        const open = () => {
          component.classList.add('-open');
        };

        const close = () => {
          const handler = () => {
            component.classList.remove('-open');
            menuBody.removeEventListener('scrollend', handler);
          };

          if (menuBody.scrollTop > 0) {
            menuBody.addEventListener('scrollend', handler);
            menuBody.scrollTo(0, 0);
          } else {
            handler();
          }
        };

        openBtn.addEventListener('click', open);
        closeBtn.addEventListener('click', close);
      }
    }
  };

  const initOpeningsDropdown = () => {
    const components = Array.from(document.querySelectorAll('.js-opening-hours'));

    components.forEach((component) => {
      const dropdown = component.querySelector('.js-opening-dropdown');
      const toggle = component.querySelector('.js-opening-toggle');

      if (toggle && dropdown) {
        toggle.addEventListener('click', () => {
          const isOpen = dropdown.classList.contains('-open');

          dropdown.classList.toggle('-open', !isOpen);
          toggle.classList.toggle('-open', !isOpen);
        });
      }
    });
  };

  const homePageTransparency = () => {
    const header = document.querySelector('.route-app-index .header-wrapper');

    if (header) {
      const handler = () => {
        if (window.scrollY > 32) {
          header.classList.remove('-transparent');
        } else {
          header.classList.add('-transparent');
        }
      };

      window.addEventListener('scroll', throttle(handler, 100));
      handler();
    }
  };

  homePageTransparency();
  initMobileMenu();
  initOpeningsDropdown();
};

export default Header;
